import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import styled from '@emotion/styled';
import { fromThemeColors } from '../Theme';
import { disabledCss, fieldCss } from './Field.styled';
export var StyledDownshiftField = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t", ";\n\t", ";\n"])), function (props) {
  return props.hasLabel && fieldCss;
}, function (props) {
  return props.disabled && disabledCss;
});
export var StyledDownshiftAutocomplete = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\tposition: relative;\n\t:focus {\n\t\tborder-color: ", ";\n\t}\n"])), fromThemeColors('focus'));